import { motion } from 'framer-motion';

export function ProgressBar({ scrollProgress, isDarkMode }) {
  return (
    <motion.div
      initial={{ scaleX: 0 }}
      animate={{ scaleX: scrollProgress }}
      className={`fixed top-0 left-0 right-0 h-[1px] ${
        isDarkMode
          ? 'bg-gradient-to-r from-jade-deep/30 via-jade/50 to-jade-deep/30'
          : 'bg-gradient-to-r from-jade-deep/50 via-jade/70 to-jade-deep/50'
      } transform origin-left z-50`}
    />
  );
}
